module.exports = __webpack_public_path__ + "img/Kate - Slider 04.35691c9a.jpg";